import { GradCtaHeroBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpGradCtaHeroBlock } from './AmpGradCtaHeroBlock';
import { GradCtaHeroBlock } from './GradCtaHeroBlock';

export const GradCtaHeroBlockMapping: BlockMapping<GradCtaHeroBlockData> = {
  invariant: [
    {
      prop: 'text',
      msg: 'Text data required for call to action',
    },
    {
      prop: 'image',
      msg: 'Image data required for call to action',
    },
  ],
  width: 'FULL',
  Component: GradCtaHeroBlock,
  AmpComponent: AmpGradCtaHeroBlock,
};
